import { render, staticRenderFns } from "./SellerPurchase.vue?vue&type=template&id=d5205582&scoped=true&"
import script from "./SellerPurchase.vue?vue&type=script&lang=js&"
export * from "./SellerPurchase.vue?vue&type=script&lang=js&"
import style0 from "./SellerPurchase.vue?vue&type=style&index=0&id=d5205582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5205582",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VFlex,VLayout})
